import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, w = 600, closeOnBackdrop = true }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)",
      }}
      onClick={closeOnBackdrop ? onClose : undefined}
    >
      <div
        style={{
          background: "#fff", borderRadius: 15,
          width: "94%", maxWidth: w, maxHeight: "90vh", overflow: "auto",
          boxShadow: "0 24px 48px -12px rgba(0,0,0,0.2)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 20px", borderBottom: "1px solid rgba(128,128,128,0.08)",
          position: "sticky", top: 0, background: "#fff", zIndex: 1,
        }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: "#333333" }}>{title}</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8" }}>
            <X size={16} />
          </button>
        </div>
        <div style={{ padding: "16px 20px" }}>{children}</div>
      </div>
    </div>
  );
}
